import { reactive } from 'vue';
import EventBus from '@/layouts/slots/event-bus';

// states scupdate reports when an update stopped without completing and
// needs attention (it keeps reporting them until a new update cycle starts).
// Anything not listed here counts as an update in progress.
export const UPDATE_ERROR_STATES = ['FAILED', 'TERMINATING', 'PAUSING'];

// states where scupdate accepts a new IcosUpdateApply. A PAUSED update
// holds its state file, so scupdate rejects a new apply until
// it is canceled on the cluster (CLI only, not in scaled's API).
export const UPDATE_RETRYABLE_STATES = ['FAILED', 'TERMINATING'];

export function isUpdateErrorState(state) {
    return UPDATE_ERROR_STATES.includes(state);
}

export function isUpdateRetryableState(state) {
    return UPDATE_RETRYABLE_STATES.includes(state);
}

// A cluster only reports a new update status on its next checkin, and
// node-ingress only forwards it when it actually changed, so right after we
// send an apply the stored status is still the old one. Remember what the
// cluster was reporting when we sent it and show the cluster as updating
// until it reports something else, so the failure the user just acted on
// doesn't sit on screen and doesn't come back looking like a new one.
// No timeout on purpose: any cutoff would resurface the old failure. Kept in
// memory, so a page reload falls back to whatever the cluster reports.
// Reactive so the widgets update on send instead of on their next poll.
const updateSentFor = reactive({});

function statusSignature(updatesStatus) {
    const status = updatesStatus ?? {};
    // percent is left out: it moves between polls without the state changing
    return JSON.stringify([status.state ?? null, status.toVersion ?? null, status.message ?? '']);
}

export function markUpdateSent(clusterId, updatesStatus) {
    updateSentFor[clusterId] = statusSignature(updatesStatus);
}

export function isUpdateSentPending(clusterId, updatesStatus) {
    const sentFor = updateSentFor[clusterId];
    return !!sentFor && sentFor === statusSignature(updatesStatus);
}

// route the version widget click: status sidebar while updating or errored
// (retry lives there), update selection otherwise
export function emitVersionClick(clusterId, { isUpdating, hasError }) {
    const event = isUpdating || hasError
        ? 'show-cluster-update-status-modal'
        : 'show-cluster-updates-available-modal';
    EventBus.emit(event, { clusterId });
}
